import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=9fa6275c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fa6275c')) {
      api.createRecord('9fa6275c', component.options)
    } else {
      api.reload('9fa6275c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=9fa6275c&", function () {
      api.rerender('9fa6275c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26pe8GTqxa6Ls/JS/offershelp.vue"
export default component.exports